import { isPressing } from './state.mjs';
/**
 * Filter out events that are not "Enter" keys.
 */

function filterEvents(callback) {
  return function (event) {
    if (event.key !== "Enter") return;
    callback(event);
  };
}

function firePointerEvent(target, type) {
  target.dispatchEvent(new PointerEvent("pointer" + type, {
    isPrimary: true,
    bubbles: true
  }));
}

var enableKeyboardPress = function enableKeyboardPress(focusEvent, eventOptions) {
  var element = focusEvent.currentTarget;
  if (!element) return;
  var handleKeydown = filterEvents(function () {
    if (isPressing.has(element)) return;
    firePointerEvent(element, "down");
    var handleKeyup = filterEvents(function () {
      firePointerEvent(element, "up");
    });

    var handleBlur = function handleBlur() {
      return firePointerEvent(element, "cancel");
    };

    element.addEventListener("keyup", handleKeyup, eventOptions);
    element.addEventListener("blur", handleBlur, eventOptions);
  });
  element.addEventListener("keydown", handleKeydown, eventOptions);
  /**
   * Add an event listener that fires on blur to remove the keydown events.
   */

  element.addEventListener("blur", function () {
    return element.removeEventListener("keydown", handleKeydown);
  }, eventOptions);
};

export { enableKeyboardPress };